import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { NonEditableFormField } from "../../guests/components/form/FormFields";
import { useTranslation } from "react-i18next";

const formatMethodLabel = (value: string | null | undefined) => {
  if (value == null || value === "") return "—";

  return value.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
};

const CHECKIN_METHOD_OPTIONS = ["FLIGHT"] as const;

const ReservationCheckinMethodSelect = ({
  value,
  onChange,
  isEdit = true,
}: {
  isEdit?: boolean;
  value: string | null | undefined;
  onChange: (value: string) => void;
}) => {
  const { t } = useTranslation();

  const selectValue =
    typeof value === "string" &&
    value !== "" &&
    CHECKIN_METHOD_OPTIONS.includes(
      value as (typeof CHECKIN_METHOD_OPTIONS)[number],
    )
      ? value
      : undefined;

  if (!isEdit) {
    return (
      <NonEditableFormField
        value={formatMethodLabel(value)}
        isCopy={false}
        label={t("reservation.form.checkInMethod")}
        labelClassName="text-foreground"
        contentClassName="h-9 mt-3 px-3 py-1 items-center border border-neutral-200 rounded-lg text-muted-foreground text-sm"
      />
    );
  }

  return (
    <div>
      <label className="block text-sm font-medium text-foreground mb-3">
        {t("reservation.form.checkInMethod")}
      </label>
      <Select value={selectValue} onValueChange={onChange}>
        <SelectTrigger
          className="w-full justify-start border border-neutral-200 rounded-lg focus-visible:border-ring data-[size=default]:h-9 aria-invalid:border-destructive cursor-pointer"
          showIcon={false}
        >
          <SelectValue
            placeholder={t("reservation.placeholders.chooseStatus")}
          />
        </SelectTrigger>
        <SelectContent>
          {CHECKIN_METHOD_OPTIONS.map((value) => (
            <SelectItem key={value} value={value}>
              <span className="text-muted-foreground">
                {formatMethodLabel(value)}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ReservationCheckinMethodSelect;
